import React from "react";
import Link from "next/link";
import { Prose } from "components/atoms/Prose";
import { formatDate } from "utils/formatDate";
import { SubTitle, Text } from "utils/styling/typography.styled";
import { BackLink, DescriptionContainer, PageWrapper, Time } from "./BlogPage.styled";
interface BlogPageProps {
  date?: string;
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  children?: React.ReactNode;
  showBackLink?: boolean;
}
export const BlogPage: React.FC<BlogPageProps> = ({
  date,
  title,
  description,
  children,
  showBackLink = true
}) => {
  return <PageWrapper data-sentry-element="PageWrapper" data-sentry-component="BlogPage" data-sentry-source-file="index.tsx">
            {showBackLink && <BackLink>
                    <Link title="Blogs" href="/blogs">
                        ← Back to Blogs
                    </Link>
                </BackLink>}
            {date ? <Time suppressHydrationWarning>{formatDate(date)}</Time> : null}
            <SubTitle data-sentry-element="SubTitle" data-sentry-source-file="index.tsx">{title}</SubTitle>
            {description ? <DescriptionContainer>
                    <Prose>
                        {typeof description === "string" ? <Text>{description}</Text> : <>{description}</>}
                    </Prose>
                </DescriptionContainer> : null}
            {children}
        </PageWrapper>;
};